var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D1F5C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8169 27.8999V14.1799H23.3369C24.3502 14.1799 25.1902 14.3599 25.8569 14.7199C26.5369 15.0799 27.0435 15.5866 27.3769 16.2399C27.7102 16.8799 27.8769 17.6199 27.8769 18.4599C27.8769 19.3532 27.6769 20.1466 27.2769 20.8399C26.8769 21.5199 26.2969 22.0399 25.5369 22.3999L28.3369 27.8999H25.0369L22.6169 22.8999H18.7969V27.8999H15.8169ZM18.7969 20.5399H22.9369C23.5369 20.5399 24.0035 20.3599 24.3369 19.9999C24.6702 19.6266 24.8369 19.1266 24.8369 18.4999C24.8369 18.0999 24.7635 17.7599 24.6169 17.4799C24.4702 17.1866 24.2569 16.9666 23.9769 16.8199C23.6969 16.6732 23.3502 16.5999 22.9369 16.5999H18.7969V20.5399Z",
    fill: "#22AB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.60efb43a1c5a77554fc2ac932a5dc5a1.svg";
export { ForwardRef as ReactComponent };